import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { timeToMinutes } from '@/utils/business-time'

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})

// Cross-field: End must be strictly after Start (user-group business hours / SLA)
extend('after_time', {
  params: ['target'],
  validate (value, { target }) {
    const end = timeToMinutes(value)
    const start = timeToMinutes(target)
    if (end == null || start == null) return true
    return end > start
  },
  message: 'End time must be after start time'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

const getValidationState = ({ dirty, validated, required: fieldRequired, changed, valid = null }) => {
  const result = dirty || validated ? valid : null
  return !fieldRequired && !changed ? null : result
}

Vue.prototype.$getValidationState = getValidationState
